import Vue from 'vue';
import includes from 'lodash/includes';
import throttle from 'lodash/throttle';

const injectedUrls = [];

export function injectScript(binding) {
  const tag = document.createElement('script');
  const head = document.getElementsByTagName('head')[0];

  tag.src = binding.url;
  tag.async = true;

  if (binding.attributes) {
    Object.keys(binding.attributes).forEach((key) => {
      tag.setAttribute(key, binding.attributes[key]);
    });
  }

  head.appendChild(tag);

  tag.onload = () => scriptLoadedEvent(binding.name, binding.url);
}

export function checkVisible(element, threshold, mode) {
  const _threshold = threshold || 0;
  const _mode = mode || 'visible';

  const rect = element.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  const above = rect.bottom - _threshold < 0;
  const below = rect.top - viewHeight + _threshold >= 0;

  return mode === 'above' ? above : _mode === 'below' ? below : !above && !below;
}

export function scriptLoadedEvent(name, url) {
  window.eventBus.$emit('script.loaded', {
    name,
    url,
  });
}

export const lazyscript = {
  bind: (el, binding) => {
    const maybeInjectScript = throttle(() => {
      if (checkVisible(el, 25)) {
        if (binding.value && binding.value.url && !includes(injectedUrls, binding.value.url)) {
          injectedUrls.push(binding.value.url);
          injectScript(binding.value);
        }
        window.removeEventListener('scroll', maybeInjectScript);
      }
    }, 500);

    window.addEventListener('scroll', maybeInjectScript);

    // call immediately to check if currently in viewport
    Vue.nextTick(maybeInjectScript);
  },
};
